var collapsible_list_component_rtlignore_default = {
  "ltr": "Vsm0c",
  "rtl": "AaFJB",
  "iconContainer": "cXTQR",
  "icon": "tWMpR",
  "isExpanded": "VSNj8",
  "listDimensions": "sKjiX"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
